import { NgModule } from '@angular/core';
import {
  PRODUCT_LIST_REVIEW_NORMALIZER,
  ProductListReviewNormalizer,
} from './converters/product-list-review-normalizer';
import { REVIEWS_NORMALIZER, ReviewsNormalizer } from './converters/reviews-normalizer';

@NgModule({
  providers: [
    {
      provide: REVIEWS_NORMALIZER,
      useExisting: ReviewsNormalizer,
      multi: true,
    },
    {
      provide: PRODUCT_LIST_REVIEW_NORMALIZER,
      useExisting: ProductListReviewNormalizer,
      multi: true,
    },
  ],
})
export class ReviewsUtilsModule {}
